import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=bfa75c94&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa75c94')) {
      api.createRecord('bfa75c94', component.options)
    } else {
      api.reload('bfa75c94', component.options)
    }
    module.hot.accept("./Select2.vue?vue&type=template&id=bfa75c94&", function () {
      api.rerender('bfa75c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Select2.vue"
export default component.exports